import { render, staticRenderFns } from "./global-only-number.vue?vue&type=template&id=7a71b998"
import script from "./global-only-number.vue?vue&type=script&lang=js"
export * from "./global-only-number.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports